<template>
    <div class="">
        <div class="block" :style="{ 'height': blockHeight }" v-if="isFixed"></div>
        <div :class="['footer-content', isFixed ? 'fixed-bottom' : '']" ref="footerRef">
            <div class="row">
                <el-row :gutter="10">
                    <el-col :md="5" :xs="24" :sm="12">
                        <div class="col-item">
                            <div class="title">
                                {{ $t('index.footer.product.title') }}
                            </div>
                            <ul>
                                <li v-for="item in someProductTypes" :key="item.id">
                                    <a @click="gotoProduct(item.id)" class="pointer-cursor">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </el-col>

                    <el-col :md="5" :xs="24" :sm="12">
                        <div class="col-item">
                            <div class="title">
                                {{ $t('index.footer.aboutUs.title') }}
                            </div>
                            <ul>
                                <li v-for="(item, index) in ($tm('index.footer.aboutUs.item') as any)" :key="index">
                                    <a :href="item.path">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                    <el-col :md="5" :xs="24" :sm="12">
                        <div class="col-item">
                            <div class="title">
                                {{ $t('index.footer.contactUs.title') }}
                            </div>
                            <ul>
                                <li v-for="(item, index) in ($tm('index.footer.contactUs.item') as any)" :key="index">
                                    <a :href="item.path">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                    <el-col :md="9" :xs="24" :sm="12">
                        <div class="col-item col-company">
                            <div class="title">
                                {{ $t('index.footer.companyInfo.title') }}
                            </div>
                            <ul>
                                <li>
                                    <el-icon class="icon">
                                        <Message />
                                    </el-icon>
                                    <span>{{ $t('index.footer.companyInfo.item[0]') }}</span>
                                </li>

                                <li>
                                    <el-icon class="icon">
                                        <Phone />
                                    </el-icon>
                                    <span>{{ $t('index.footer.companyInfo.item[1]') }}</span>
                                </li>

                                <li>
                                    <el-icon class="icon">
                                        <Location />
                                    </el-icon>
                                    <span>{{ $t('index.footer.companyInfo.item[2]') }}</span>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action, LanguageType } from '@/typeDefine/CommonTypes';
import { LanguagePackageType } from '@/typeDefine/EntityType';
import { GetSomeProductTypesResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { nextTick, onBeforeUnmount, onMounted, ref, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { debounce } from 'lodash-es'

const { t } = useI18n<[LanguagePackageType], LanguageType>()

const footerRef: Ref<Element | null> = ref(null)
const blockHeight: Ref<number> = ref(0)

const isFixed: Ref<boolean> = ref(false)

const someProductTypes: Ref<GetSomeProductTypesResponse['data']['someTypes']> = ref([])
let observer: MutationObserver | null = null

onMounted(() => {
    window.addEventListener('resize', checkFooterPosition)

    requestSomeProducType()

    observer = new MutationObserver(
        debounce(() => {
            checkFooterPosition()
        }, 100)
    )
    observer.observe(document.body, { childList: true, subtree: true })
})

//用于检测屏幕是否撑满
const checkFooterPosition: Action = () => {

    setTimeout(() => {
        const bodyHeight = document.body.scrollHeight
        const viewportHeight = window.innerHeight
        isFixed.value = bodyHeight <= viewportHeight

        nextTick(() => {
            if (!footerRef.value) {
                return
            }

            blockHeight.value = footerRef.value.getBoundingClientRect().height
        })
    }, 500);

}

//请求部分产品类别
const requestSomeProducType: Action = async () => {
    const response: GetSomeProductTypesResponse = await Api.instance.getSomeProductTypes({
        size: 5
    })

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        someProductTypes.value = response.data.someTypes
    }
}

//前往产品页面
const gotoProduct: Action<[number]> = (typeId: number) => {
    router.push({
        name: 'products',
        query: {
            typeId: `${typeId}`
        }
    })
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkFooterPosition)
    observer?.disconnect()
})
</script>

<style lang="css" scoped>
.el-col {
    margin-bottom: 20px;
}

.footer-content {
    background-color: var(--primary-color);
}

.footer-content .row {
    width: 92%;
    margin: 0 auto;
    padding: 50px 0;
    max-width: 1200px;
}

.footer-content .row .col-item .title {
    color: #fff;
    border-left: 5px solid #feb900;
    padding-left: 17px;
    margin-bottom: 11px;
}

.footer-content .row .col-item ul {
    padding: 0 0 0 22px;
}

.footer-content .row .col-item ul li {
    list-style: none;
    font-size: 14px;
    margin: 0 0 11px 0;
}

.footer-content .row .col-item ul li a {
    text-decoration: none;
    color: #869cc1;
}

.footer-content .row .col-company ul li {
    display: flex;
    align-items: center;
    color: #869cc1;
}

.footer-content .row .col-company ul li .icon {
    margin-right: 6px;
    font-size: 20px;
}
</style>